import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ModeEvaluationResponse, TypeDossierEvaluationResponse } from '@/types/scenarios.types';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ModeEvaluationService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.api.paramsUrl}/mode-evaluation`;

  getAllModeEvaluations(query?: any): Observable<ModeEvaluationResponse[]> {
    return this.http.get<ModeEvaluationResponse[]>(this.baseUrl, { params: query });
  }

  getModeEvaluationById(id: number): Observable<ModeEvaluationResponse> {
    return this.http.get<ModeEvaluationResponse>(`${this.baseUrl}/${id}`);
  }

  getTypeDossierEvaluations(query?: any): Observable<TypeDossierEvaluationResponse[]> {
    return this.http.get<TypeDossierEvaluationResponse[]>(`${this.baseUrl}/type-dossier`, { params: query });
  }

  getAllowedModesByTypeDossierId(typeDossierId: number): Observable<TypeDossierEvaluationResponse[]> {
    return this.http.get<TypeDossierEvaluationResponse[]>(`${this.baseUrl}/type-dossier/${typeDossierId}`);
  }

  getAllowedModesByTypeDossierCode(code: string): Observable<TypeDossierEvaluationResponse[]> {
    return this.http.get<TypeDossierEvaluationResponse[]>(`${this.baseUrl}/type-dossier/code/${code}`);
  }
}
